// 创美官网 - 路由配置

import { lazy, Suspense } from 'react';
import type { FC } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { PageLoading } from '../components/common/PageLoading';

// 路由懒加载
const HomePage = lazy(() => import('../pages/HomePage'));
const AboutPage = lazy(() => import('../pages/AboutPage'));
const NewsPage = lazy(() => import('../pages/NewsPage'));
const NewsDetailPage = lazy(() => import('../pages/NewsDetailPage'));
const CareersPage = lazy(() => import('../pages/CareersPage').then(m => ({ default: m.CareersPage })));
const CampusRecruitmentPage = lazy(() => import('../pages/CampusRecruitmentPage'));
const JobDetailPage = lazy(() => import('../pages/JobDetailPage'));
const InvestorPage = lazy(() => import('../pages/InvestorPage').then(m => ({ default: m.InvestorPage })));
const AnnouncementsPage = lazy(() => import('../pages/AnnouncementsPage').then(m => ({ default: m.AnnouncementsPage })));
const FinancialReportsPage = lazy(() => import('../pages/FinancialReportsPage').then(m => ({ default: m.FinancialReportsPage })));
const GovernancePage = lazy(() => import('../pages/GovernancePage').then(m => ({ default: m.GovernancePage })));
const InvestorInquiryPage = lazy(() => import('../pages/InvestorInquiryPage/InvestorInquiryPage'));
const ContactPage = lazy(() => import('../pages/ContactPage').then(m => ({ default: m.ContactPage })));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage').then(m => ({ default: m.NotFoundPage })));
// const ThemeTestPage = lazy(() => import('../pages/ThemeTestPage/ThemeTestPage'));

// Suspense 包装组件
const withSuspense = (Component: FC) => (
  <Suspense fallback={<PageLoading />}>
    <Component />
  </Suspense>
);

// 路由配置
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: withSuspense(NotFoundPage),
    children: [
      {
        index: true,
        element: withSuspense(HomePage),
      },
      {
        path: 'about/*',
        element: withSuspense(AboutPage),
      },
      {
        path: 'news',
        element: withSuspense(NewsPage),
      },
      {
        path: 'news/:id',
        element: withSuspense(NewsDetailPage),
      },
      {
        path: 'careers',
        element: withSuspense(CareersPage),
      },
      {
        path: 'careers/social',
        element: withSuspense(CareersPage),
      },
      {
        path: 'careers/campus',
        element: withSuspense(CampusRecruitmentPage),
      },
      {
        path: 'careers/:id',
        element: withSuspense(JobDetailPage),
      },
      {
        path: 'investor',
        element: withSuspense(InvestorPage),
      },
      {
        path: 'investor/service',
        element: withSuspense(InvestorPage),
      },
      {
        path: 'investor/announcements',
        element: withSuspense(AnnouncementsPage),
      },
      {
        path: 'investor/financial-reports',
        element: withSuspense(FinancialReportsPage),
      },
      {
        path: 'investor/governance',
        element: withSuspense(GovernancePage),
      },
      {
        path: 'investor/inquiry',
        element: withSuspense(InvestorInquiryPage),
      },
      {
        path: 'contact',
        element: withSuspense(ContactPage),
      },
      // {
      //   path: 'theme-test',
      //   element: withSuspense(ThemeTestPage),
      // },
    ],
  },
]);

export { router };
export default router;